export const TIMESHEET_HOLIDAY_CREATE_REQUESTED =
    'TIMESHEET_HOLIDAY_CREATE_REQUESTED';
export const TIMESHEET_HOLIDAY_CREATE_SUCCEEDED =
    'TIMESHEET_HOLIDAY_CREATE_SUCCEEDED';
export const TIMESHEET_HOLIDAY_CREATE_FAILED =
    'TIMESHEET_HOLIDAY_CREATE_FAILED';

export const TIMESHEET_HOLIDAY_UPDATE_REQUESTED =
    'TIMESHEET_HOLIDAY_UPDATE_REQUESTED';
export const TIMESHEET_HOLIDAY_UPDATE_SUCCEEDED =
    'TIMESHEET_HOLIDAY_UPDATE_SUCCEEDED';
export const TIMESHEET_HOLIDAY_UPDATE_FAILED =
    'TIMESHEET_HOLIDAY_UPDATE_FAILED';

export const TIMESHEET_HOLIDAYS_SET = 'TIMESHEET_HOLIDAYS_SET';
export const TIMESHEET_HOLIDAY_SET = 'TIMESHEET_HOLIDAY_SET';

export const TIMESHEET_HOLIDAYS_MULTIPLIER = 1.5;
